import { get, post, put } from '../utils/axios'

export const getChecklistNewStatusAPI = async () => {
  return await get('checklist/status')
}

export const getChecklistNewAPI = async (body) => {
  return await get('checklist/new', body)
}
export const putChecklistNewOneAPI = async (params, body) => {
  return await put('checklist/new/one', params, body)
}

export const putChecklistNewFiveAPI = async (params, body) => {
  return await put('checklist/new/five', params, body)
}

export const putChecklistNewTwoAPI = async (params, body) => {
  return await put('checklist/new/two', params, body)
}
export const putChecklistNewThreeAPI = async (params, body) => {
  return await put('checklist/new/three', params, body)
}
export const postChecklistNewThreeSupAPI = async (body) => {
  return await post('checklist/new/three/it', body)
}

export const postChecklistNewTwoITAPI = async (body) => {
  return await post('checklist/new/two/it', body)
}

export const getChecklistNewStepAPI = async () => {
  return await get('checklist/new/step')
}

export const getChecklistNewStepDetailAPI = async (data) => {
  return await get('checklist/new/detail', data)
}
export const getChecklistNewFloorDetailAPI = async (body) => {
  return await get('checklist/new/floor/detail', body)
}

export const getChecklistNewFloorBuildAPI = async (body) => {
  return await get('checklist/new/floor/build', body)
}

export const getChecklistNewFloorTypeAPI = async (body) => {
  return await get('checklist/new/floor/type', body)
}

export const getChecklistNewFloorAPI = async (body) => {
  return await get('checklist/new/floor', body)
}

export const cancelChecklistNewAPI = async (body) => {
  return await post('checklist/new/cancel', body)
}

// Resign

export const getChecklistResignAPI = async (body) => {
  return await get('checklist/resign', body)
}
// get
export const getChecklistResignDetailITAPI = async (param) => {
  return await get('checklist/resign/detail/it', param)
}
export const putChecklistResignPDAPI = async (params, body) => {
  return await put('checklist/resign/pd', params, body)
}
export const getChecklistStatusAPI = async () => {
  return await get('status')
}
//submitAll
export const putChecklistResignITAPI = async (params, body) => {
  return await put('checklist/resign/it', params, body)
}
// subConfirm
export const putChecklistResignITDeatilAPI = async (params, body) => {
  return await put('checklist/resign/it/detail', params, body)
}

export const getChecklistResignDetailAPI = async (body) => {
  return await get('checklist/resign/detail', body)
}

// IT ASSETS
export const getChecklistITAssetResignDetailAPI = async (body) => {
  return await get('checklist/resign/detail/it/asset', body)
}

export const putChecklistResignITAssetAPI = async (params, body) => {
  return await put('checklist/resign/it/asset', params, body)
}

//PD ASSETS
export const getChecklistPDAssetResignDetailAPI = async (body) => {
  return await get('checklist/resign/detail/pd/asset', body)
}

export const putChecklistResignPDAssetAPI = async (params, body) => {
  return await put('checklist/resign/pd/asset', params, body)
}

//ADMIN (PD)
export const putChecklistResignPDAdminAPI = async (params, body) => {
  return await put('/checklist/resign/pd', params, body)
}

// submitSupervisor
export const putChecklistResignIT2API = async (param) => {
  return await put('checklist/resign/it/sup', param)
}
export const cancelChecklistResignAPI = async (body) => {
  return await post('checklist/resign/cancel', body)
}

export const getChecklistNotebookTypeAPI = async () => {
  return await get('checklist/notebook/type')
}

export const putChecklistUsernameAPI = async (data) => {
  return await put('emps/checks/username', {}, data)
}
